module.exports = __webpack_public_path__ + "assets/img/businessman.0fae3835.png";